module.exports = __webpack_public_path__ + "static/about-background-bd3b70c190aecb06c6f3bf249c6eea7e.svg";